import Controller from "./buses.controller";
import template from "./buses.html";

const buses = {
  template,
  controller: Controller,
};

export default buses;



// WEBPACK FOOTER //
// ./src/pages/buses/buses.component.js